import { Component } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { DemoComplexConditionsService } from '@demo/module-definition/demo-complex-conditions/demo-complex-conditions.service';
import { ComplexConditionsListService } from '@module-definition/complex-conditions/complex-conditions-list/complex-conditions-list.service';
import { ComplexConditionsListComponent } from '../../../module/definition/complex-conditions/complex-conditions-list/complex-conditions-list.component';

@Component({
  selector: 'app-demo-complex-conditions',
  templateUrl: './demo-complex-conditions.component.html',
  imports: [ComplexConditionsListComponent, MatTableModule],
  providers: [{ provide: ComplexConditionsListService, useClass: DemoComplexConditionsService }],
})
export class DemoComplexConditionsComponent {}
